import React from "react";
import { Select, Typography } from "antd";

const { Text } = Typography;

export default function CollectiveChargeSection({
  isCollective,
  chargeType,
  onChargeTypeChange,
  users,
  selectedUsers,
  onSelectedUsersChange,
  requesterId,
}) {
  return (
    <div style={{ marginTop: 16 }}>
      <Text>Selecciona el tipo de cobro:</Text>
      <Select
        value={chargeType}
        size="large"
        style={{ width: "100%", marginTop: 8 }}
        onChange={onChargeTypeChange}
        options={[
          { value: "individual", label: "Cobro individual" },
          { value: "colectivo", label: "Cobro colectivo" },
        ]}
      />

      {isCollective && (
        <div style={{ marginTop: 12 }}>
          <Text>Selecciona los usuarios:</Text>
          <Select
            mode="multiple"
            showSearch
            value={selectedUsers}
            placeholder="Selecciona los usuarios para el cobro colectivo"
            size="large"
            style={{ width: "100%", marginTop: 8 }}
            options={users.map((user) => ({
              value: user.id,
              label: user.id === requesterId ? `${user.name} (Tú)` : user.name,
            }))}
            filterOption={(input, option) =>
              option?.label?.toLowerCase().includes(input.toLowerCase())
            }
            onChange={(selectedUserIds) => {
              const updated = selectedUserIds.includes(requesterId)
                ? selectedUserIds
                : [requesterId, ...selectedUserIds];
              onSelectedUsersChange(updated);
            }}
          />
        </div>
      )}
    </div>
  );
}
